var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBody(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.508,
    height: 95.119,
    viewBox: "0 0 76.508 95.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_\\xFCbungen",
    transform: "translate(-130.991 150.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13048",
    "data-name": "Group 13048",
    transform: "translate(132 -149.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14945",
    "data-name": "Path 14945",
    d: "M121.15,13.6A10.107,10.107,0,1,1,111.043,3.5,10.107,10.107,0,0,1,121.15,13.6Z",
    transform: "translate(-73.72 -3.496)",
    fill: "none",
    stroke: "#f95047",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14946",
    "data-name": "Path 14946",
    d: "M75.975,30.433,54.51,45.139a.677.677,0,0,0-.293.575v21.06a.649.649,0,0,0,.02.165l9.376,37.212a4.638,4.638,0,1,1-8.994,2.268L46.572,74.485a.681.681,0,0,0-.659-.514H44.57a3.9,3.9,0,0,1-.554-.039,23.124,23.124,0,0,0-6.551,0,3.9,3.9,0,0,1-.554.039H35.568a.679.679,0,0,0-.659.514l-8.047,31.933a4.638,4.638,0,1,1-8.994-2.268l9.376-37.212a.649.649,0,0,0,.02-.165V45.714a.686.686,0,0,0-.3-.575L5.506,30.433a4.637,4.637,0,0,1,5.243-7.65L26.3,33.435a25.555,25.555,0,0,0,28.888,0L70.732,22.783a4.637,4.637,0,1,1,5.243,7.65Z",
    transform: "translate(-3.495 -16.814)",
    fill: "none",
    stroke: "#f95047",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody);
export default __webpack_public_path__ + "static/media/body.d54c5f03817ef2ef867979e2781331e3.svg";
export { ForwardRef as ReactComponent };